import { render } from "./DoubleProgressBar.vue?vue&type=template&id=49f298bc&scoped=true"
import script from "./DoubleProgressBar.vue?vue&type=script&lang=js"
export * from "./DoubleProgressBar.vue?vue&type=script&lang=js"

import "./DoubleProgressBar.vue?vue&type=style&index=0&id=49f298bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f298bc"]])

export default __exports__